/* eslint-disable no-console */
'use client'

import { ReactNode, useEffect } from 'react'

import useToast from '@/libs/hooks/use-toast'

export default function ToastFallback({
  error,
  children,
}: {
  readonly error?: Error & { digest?: string }
  readonly reset?: { label?: string; action?: () => void }
  readonly children?: ReactNode
}) {
  const toast = useToast()

  useEffect(() => {
    toast.show({
      title: error?.name || 'Error Occured',
      description: error?.message || "Sorry, we're currently experiencing an issue.",
      type: 'error',
    })

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return children
}
